import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Clientes',
  },
  {
    displayName: 'Ver Clientes',
    iconName: 'users',
    route: '/clientes/ver-clientes',
  },

  {
    displayName: 'Invoices',
    iconName: 'file-invoice',
    route: '/clientes/invoices',
  },

  {
    displayName: 'Notas de Credito',
    iconName: 'notes',
    route: '/invoice/nota-credito',
  },
  {
    displayName: 'Account Statement',
    iconName: 'report-search',
    route: '/clientes/account-statement',
  },

  {
    navCap: 'Proveedores',
  },

  {
    displayName: 'Proveedores ADM',
    iconName: 'address-book',
    children: [
      {
        displayName: 'Ver Proveedores',
        iconName: 'point',
        route: '/pagos-administrativos/proveedores',
      },
      {
        displayName: 'Nuevo Proveedor',
        iconName: 'point',
        route: '/pagos-administrativos/nuevo-proveedor',
      },
    ],
  },
  {
    displayName: 'Proveedores SRC',
    iconName: 'user-search',
    children: [
      {
        displayName: 'Ver Proveedores',
        iconName: 'point',
        route: '/proveedores-sourcing/ver-proveedores',
      },
    ],
  },

  {
    navCap: 'Registro de Compras',
  },

  {
    displayName: 'Orden de Servicio',
    iconName: 'receipt',
    children: [
      {
        displayName: 'Listar OS',
        iconName: 'point',
        route: '/pagos-administrativos/listar-OS',
      },
    ],
  },
  {
    displayName: 'Orden de Compra',
    iconName: 'shopping-cart',
    children: [
      {
        displayName: 'Crear OC',
        iconName: 'point',
        route: '/pagos-administrativos/nuevo-OC',
      },
      {
        displayName: 'Listar OC',
        iconName: 'point',
        route: '/pagos-administrativos/listar-OC',
      },
    ],
  },

  {
    displayName: 'Bitácora de Compras',
    iconName: 'clipboard-list',
    children: [
      {
        displayName: 'Crear B. de Compras',
        iconName: 'point',
        route: '/pagos-administrativos/nuevo-RC',
      },
      {
        displayName: 'Listado de B. de Compras',
        iconName: 'point',
        route: '/pagos-administrativos/listar-RC',
      },
    ],
  },

  {
    navCap: 'Registro de Ingresos',
  },

  {
    displayName: 'Orden de Ingreso',
    iconName: 'ticket',
    children: [
      {
        displayName: 'Crear OI',
        iconName: 'point',
        route: '/ingresos-administrativos/nuevo-OI',
      },
      {
        displayName: 'Listar OI',
        iconName: 'point',
        route: '/ingresos-administrativos/listar-OI',
      },
    ],
  },

  {
    navCap: 'Transacciones',
  },

  {
    displayName: 'Cargar Mov. Bancarios',
    iconName: 'file-upload',
    route: '/transacciones/cargar-movimientos-bancarios',
  },
  {
    displayName: 'Movimientos Bancarios',
    iconName: 'credit-card-pay',
    route: '/transacciones/movimientos-bancarios',
  },
  {
    displayName: 'Cargar Reporte de Trans.',
    iconName: 'file-upload',
    route: '/transacciones/cargar-reporte-transacciones',
  },
  {
    displayName: 'Reporte de Transacciones',
    iconName: 'table',
    route: '/transacciones/lista-reporte-transacciones',
  },
  {
    displayName: 'Cuentas de Banco',
    iconName: 'building-bank',
    route: '/transacciones/cuentas-bancos',
  },

  {
    navCap: 'Tesorería',
  },

  {
    displayName: 'C.Bancaria Egresos',
    iconName: 'basket-dollar',
    route: '/tesoreria/conciliacion-bancaria-egresos',
  },
  {
    displayName: 'C. Bancaria Ingresos',
    iconName: 'wallet',
    route: '/tesoreria/conciliacion-bancaria-ingresos',
  },

  {
    displayName: 'C. Bancaria de Transac.',
    iconName: 'credit-card',
    route: '/tesoreria/conciliacion-bancaria-transacciones',
  },

  {
    displayName: 'Pagos del Día',
    iconName: 'calendar-check',
    route: '/tesoreria/pagos-dia',
  },
  {
    displayName: 'Control Diario',
    iconName: 'clipboard-list',
    route: '/tesoreria/control-diario',
  },

  {
    displayName: 'Saldos Act.Banc',
    iconName: 'checklist',
    route: '/tesoreria/saldos-actividades-bancarias-diarias',
  },

  {
    navCap: 'Gestion de Proveedores',
  },

  {
    displayName: 'Notas de Credito',
    iconName: 'note',
    route: '/gestion-proveedores/notas-credito',
  },
];
